import React from 'react';

function CompetitorComparison() {
  return (
    <section className="bg-gray-50 py-20">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <header className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-extrabold tracking-tight mb-4">
            Stop Losing Business on the Phone.
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Your phone is your lifeline. Yet, most AI assistants just take messages. <span className="font-bold bg-gradient-to-r from-indigo-600 to-pink-500 bg-clip-text text-transparent">Remote-Assistant.ai</span> answers, books, and <span className="font-bold">gets you paid</span>—all in one call. See how we stack up.
          </p>
        </header>

        {/* Feature Scorecard */}
        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 mb-12">
          <h3 className="text-3xl font-bold text-center mb-8">Feature Scorecard: The Modern AI Assistant</h3>
          <div className="overflow-x-auto">
            <table className="w-full min-w-[700px] text-left border-collapse">
              <thead>
                <tr className="bg-gray-800 text-white">
                  <th className="p-4 rounded-tl-lg text-lg font-semibold">Core Feature</th>
                  <th className="p-4 text-center text-lg font-semibold bg-indigo-50 text-gray-800">Remote-Assistant.ai</th>
                  <th className="p-4 text-center text-lg font-semibold">Smith.ai</th>
                  <th className="p-4 text-center text-lg font-semibold">Goodcall</th>
                  <th className="p-4 rounded-tr-lg text-center text-lg font-semibold">Acuity Scheduling</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200">
                  <td className="p-4 font-medium">Live Payment Verification (During Call)</td>
                  <td className="p-4 text-center text-2xl font-bold bg-indigo-50 text-green-500">✔</td>
                  <td className="p-4 text-center text-2xl font-bold text-red-500">✘</td>
                  <td className="p-4 text-center text-2xl font-bold text-red-500">✘</td>
                  <td className="p-4 text-center text-2xl font-bold text-yellow-500">●</td>
                </tr>
                <tr className="border-b border-gray-200 bg-gray-50">
                  <td className="p-4 font-medium">Simultaneous Voice + SMS Workflow</td>
                  <td className="p-4 text-center text-2xl font-bold bg-indigo-50 text-green-500">✔</td>
                  <td className="p-4 text-center text-2xl font-bold text-yellow-500">●</td>
                  <td className="p-4 text-center text-2xl font-bold text-yellow-500">●</td>
                  <td className="p-4 text-center text-2xl font-bold text-red-500">✘</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="p-4 font-medium">Deposit-Driven Booking Commitment</td>
                  <td className="p-4 text-center text-2xl font-bold bg-indigo-50 text-green-500">✔</td>
                  <td className="p-4 text-center text-2xl font-bold text-red-500">✘</td>
                  <td className="p-4 text-center text-2xl font-bold text-red-500">✘</td>
                  <td className="p-4 text-center text-2xl font-bold text-green-500">✔</td>
                </tr>
                <tr className="border-b border-gray-200 bg-gray-50">
                  <td className="p-4 font-medium">24/7 AI-Powered Availability</td>
                  <td className="p-4 text-center text-2xl font-bold bg-indigo-50 text-green-500">✔</td>
                  <td className="p-4 text-center text-2xl font-bold text-yellow-500">●</td>
                  <td className="p-4 text-center text-2xl font-bold text-green-500">✔</td>
                  <td className="p-4 text-center text-2xl font-bold text-green-500">✔</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="p-4 font-medium">No Human Follow-Up Required</td>
                  <td className="p-4 text-center text-2xl font-bold bg-indigo-50 text-green-500">✔</td>
                  <td className="p-4 text-center text-2xl font-bold text-red-500">✘</td>
                  <td className="p-4 text-center text-2xl font-bold text-yellow-500">●</td>
                  <td className="p-4 text-center text-2xl font-bold text-green-500">✔</td>
                </tr>
                <tr className="bg-gray-50">
                  <td className="p-4 font-medium rounded-bl-lg">Built for Small Businesses</td>
                  <td className="p-4 text-center text-2xl font-bold bg-indigo-50 text-green-500">✔</td>
                  <td className="p-4 text-center text-2xl font-bold text-green-500">✔</td>
                  <td className="p-4 text-center text-2xl font-bold text-green-500">✔</td>
                  <td className="p-4 text-center text-2xl font-bold text-green-500">✔</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="mt-6 text-sm text-gray-500">
            <p><span className="font-bold text-green-500">✔</span> Full Feature: Core offering, works as described.</p>
            <p><span className="font-bold text-yellow-500">●</span> Partial/Indirect: Feature exists but may require human intervention, manual setup, or is not the primary function.</p>
            <p><span className="font-bold text-red-500">✘</span> Not a core feature or not available.</p>
          </div>
        </div>

        {/* Conclusion CTA */}
        <section className="bg-gray-800 text-white rounded-xl shadow-2xl p-8 md:p-12 text-center">
          <h3 className="text-4xl font-extrabold mb-4">The Bottom Line: From "Hello" to Paid.</h3>
          <p className="text-lg md:text-xl text-gray-300 max-w-4xl mx-auto mb-6">
            Other tools solve one piece of the puzzle. Schedulers don't talk, and receptionists can't take payments securely on the call. Remote-Assistant.ai is the only solution built from the ground up for small business owners who live and die by the phone, turning every answered call into a secured, committed booking.
          </p>
          <button className="bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-3 px-8 rounded-full text-lg transition duration-300 shadow-lg transform hover:scale-105">
            Start Converting More Calls Today
          </button>
        </section>
      </div>
    </section>
  );
}

export default CompetitorComparison;